import React from 'react';
import { Title } from 'components/Toolbar/constants';
import Control from 'components/Toolbar/Controls/Control';
import { ControlState } from 'components/Toolbar/Controls/Control/constants';
import Dropdown from 'components/Toolbar/Controls/TextVerticalAlignment/Dropdown';
import { useControlWithDropdown } from 'components/Toolbar/hooks';
import { TEXT_VERTICAL_ALIGNMENTS } from './const';
import { TextVerticalAlignmentProps } from './models';

const TextVerticalAlignment: React.FunctionComponent<TextVerticalAlignmentProps> = (props) => {
  const {
    alignment,
    toggleAlignment,
    controlState = ControlState,
    dataTestId = 'textVerticalAlignment',
  } = props;
  const { control, isOpen, state, toggleDropdown } = useControlWithDropdown({ controlState });

  const icon = TEXT_VERTICAL_ALIGNMENTS.find(a => a.type === alignment)?.icon;

  return (
    <Control
      controlState={controlState}
      onToggle={toggleDropdown}
      ref={control}
      state={state}
      title={Title.TEXT_ALIGNMENT_VERTICAL}
      type={icon}
      dataTestId={`${dataTestId}-control`}
    >
      {isOpen && <Dropdown alignment={alignment} toggleAlignment={toggleAlignment} dataTestId={`${dataTestId}-dropdown`} />}
    </Control>
  );
};

export default TextVerticalAlignment;
